import { render, staticRenderFns } from "./CreatedInvoice.vue?vue&type=template&id=a67af4cc&scoped=true&"
import script from "./CreatedInvoice.vue?vue&type=script&lang=js&"
export * from "./CreatedInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CreatedInvoice.vue?vue&type=style&index=0&id=a67af4cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67af4cc",
  null
  
)

export default component.exports